import { makeAutoObservable } from "mobx"
import DraftUpload from "./DraftUpload"
import ActionInsight from "./ActionInsight"
import ActionDraft from "./ActionDraft"

export default class Action {

  constructor(action = {}) {
    this.id = action.id
    this.post_url = action.post_url || ''
    this.campaign_id = action.campaign_id
    this.authentication_id = action.authentication_id
    this.influencer_id = action.influencer_id
    this.campaign_scenario_action_group_id = action.campaign_scenario_action_group_id
    this.slot_number = action.slot_number || 1
    this.ksa_tax_enabled = !!action.ksa_tax_enabled
    this.impression = action.impression || 0
    this.reach = action.reach
    this.buyout = !!action.buyout
    this.buyout_price = action.buyout_price || 0
    this.influencer_payout_price = action.influencer_payout_price || 0
    this.provider = action.provider
    this.visible_in_budget = action.visible_in_budget
    this.action_type = action.action_type
    this.advertiser_margin = action.advertiser_margin || 0
    this.influencer_payout_margin = action.influencer_payout_margin || 0
    this.avatar = action.avatar
    this.caption = action.caption
    this.name = action.name
    this.influencer_name = action.influencer_name
    this.influencer_email = action.influencer_email
    this.scenario_name = action.scenario_name
    this.start_date = action.start_date
    this.end_date = action.end_date
    this.notes = action.notes ?? ''
    this.draftAccepted = action.draft_accepted
    this.auth_username = action.username
    this.draft_is_visible = action.draft_is_visible
    this.advApproved = action.advertiser_approved
    this.auth_engagement_rate = action.auth_engagement_rate
    this.auth_country = action.auth_country
    this.draft_uploads = action.draft_uploads?.map(upload => new DraftUpload(upload)) || []
    this.action_insight = action.action_insight ? new ActionInsight(action.action_insight) : null
    this.action_draft = action.action_draft ? new ActionDraft(action.action_draft) : null
    makeAutoObservable(this)
  }

  get influencerPrice() {
    return this.influencer_payout_price / (1 - (this.influencer_payout_margin / 100))
  }

  get ksaPrice() {
    return this.ksa_tax_enabled ? this.influencer_payout_price * 0.049 : 0
  }

  get advertiserMarginPrice() {
    return (this.influencerPrice + this.buyoutPrice) * this.advertiser_margin / 100
  }

  get influencerPayoutMarginPrice() {
    return this.influencerPrice - this.influencer_payout_price
  }

  get advertiserPrice() {
    return this.influencerPrice * (1 + (this.advertiser_margin / 100)) + this.ksaPrice
  }

  get advertiserImpressionCPM() {
    return this.impression ? (this.advertiserPrice / this.impression) * 1000 : 0
  }

  get advertiserFollowerCPM() {
    return (this.advertiserPrice / this.reach) * 1000
  }

  get buyoutPrice() {
    return this.buyout ? this.buyout_price : 0
  }

  get buyoutKsaPrice() {
    return this.ksa_tax_enabled ? this.buyoutPrice * 0.049 : 0
  }

  get buyoutAdvertiserPrice() {
    return this.buyoutPrice * (1 + (this.advertiser_margin / 100)) + this.buyoutKsaPrice
  }

  get totalKsaPrice() {
    return this.buyoutKsaPrice + this.ksaPrice
  }

  get totalAdvertiserPrice() {
    return this.advertiserPrice + this.buyoutAdvertiserPrice
  }
}
